import * as _4 from 'lodash4';

export class ScreenQueryServant {
  screenQueryInstance = window['HIP'].factory.queryOne('yi-layout-screen-query').instance;

  isScreenDesktop() {
    if (!this.screenQueryInstance || !this.screenQueryInstance.isDesktop) {
      return true;
    }
    return this.screenQueryInstance.isDesktop();
  }

  isScreenMobile() {
    if (!this.screenQueryInstance || !this.screenQueryInstance.isMobile) {
      return false;
    }
    return this.screenQueryInstance.isMobile();
  }
}

angular.module('ng-screen-query').service('ngScreenQueryServant', ScreenQueryServant);



// WEBPACK FOOTER //
// ./app/vendor/screen-query/src/servants/screen_query_servant.ts